"use client";

import { URL } from "@constants/path";
import fetchApi from "@hooks/useFetch";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";


const NewsletterSection1 = () => {
    const recaptchaRef = useRef(null);
    const [mail, setMail] = useState("");
    const [isSend, setSend] = useState(false);
    const [isHelpChecked, setIsHelpChecked] = useState(true);
    const [isSubscribedChecked, setIsSubscribedChecked] = useState(true);
    const [error, setError] = useState("");
    const [mailError, setMailError] = useState("");


    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handlNewsletter = async (e) => {
        e.preventDefault();
        if (!mail.trim()) {
            setError("Veuillez remplir le courriel.");
            return;
        } else {
            setError("");
        }
        if (!validateEmail(mail)) {
            setMailError("Adresse e-mail invalide");
            return;
          }

        if (recaptchaRef.current) {
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            if (!recaptchaToken) {
                console.error("Le reCAPTCHA a échoué ou n'a pas été validé.");
                return;
            }
            const params = {
                is_api: 1,
                mail: mail,
                isSubscribedChecked,
                recaptchaToken
            };

            fetchApi(URL.NEWSLETTER, "POST", params).finally(() => setSend(true));
        } else {
            console.error("Échec de l'obtention du token reCAPTCHA.");
        }

    }
    
    return (
        <>
            <div className="pt-24 pb-12">
                <div className="container">
                    <div className="newsletter1 py-16 rounded-3xl px-10 text-center">
                        <h2 className="text-[48px] leading-[54px] font-semibold tracking-[-2px] mb-5 text-white wow animate__animated animate__fadeInUp">{isSend ? "L'aide est en route !" : "Besoin d'aide ?"}</h2>
                        <p className="text-lg text-gray-100  wow animate__animated animate__fadeInUp mb-4">
                            {isSend ?
                                "Notre équipe de spécialiste se mobilise pour vous. Surveiller votre boite courriel, vous y recevrez sous peu une communication de notre équipe afin de vous aider dans vos recherches." :
                                "Écrivez-nous et obtenez de l'aide rapidement dans vos démarches!"}</p>

                        {!isSend &&
                            <>
                                <div className="flex max-w-xl mx-auto rounded-xl bg-white mt-10 px-3 py-2 wow animate__animated animate__fadeInUp">
                                    <input type="text" className="input w-full rounded-xl" onChange={(e) => {
                                        const val = e.target.value;
                                        setMail(val);
                                        if (!validateEmail(val)) {
                                            setMailError("Adresse e-mail invalide");
                                            setError("");
                                        } else {
                                            setMailError("");
                                        }
                                    }} placeholder="Votre courriel" />
                                    <button className="btn bg-primary-1000 hover:bg-primary-1000 transition duration-150  rounded-xl text-white shadow-sm px-7"
                                        onClick={handlNewsletter}>Envoyer</button>
                                </div>
                                {mailError && (
                                    <div className="wow bg-white text-center animate__animated animate__fadeInUp custom-margin-top" style={{ maxWidth: "570px", padding: "10px", borderRadius: "10px", margin: "auto" }}>
                                    <p className="text-red-500 text-sm">
                                        {mailError}
                                    </p>
                                </div>
                                )}

                                {error && (
                                    <div className="wow bg-white text-center animate__animated animate__fadeInUp custom-margin-top" style={{ maxWidth: "570px", padding: "10px", borderRadius: "10px", margin: "auto" }}>
                                        <p className="text-red-500 text-sm">
                                            {error}
                                        </p>
                                    </div>

                                )}
                            </>}
                        {!isSend && <div className="mt-4 wow text-center animate__animated animate__fadeInUp text-white" style={{ maxWidth: "570px", padding: "10px", borderRadius: "10px", margin: "auto" }}>
                            <label className="flex items-start size-custom-14">
                                <input
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    checked={isHelpChecked}
                                    onChange={() => setIsHelpChecked(!isHelpChecked)}
                                    className="mr-2 mt-1"
                                />
                                <span className="text-left">Je désire  <strong> obtenir de l&apos;aide</strong> dans mes recherches.</span>
                            </label>
                            <label className="flex items-start mt-1 mb-4 size-custom-14">
                                <input
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    checked={isSubscribedChecked}
                                    onChange={() => setIsSubscribedChecked(!isSubscribedChecked)}
                                    className="mr-2 mt-1"
                                />
                                <span className="text-left">Abonnez-moi aux <strong>nouvelles exclusives</strong> du site Vieillir à la maison!</span>
                            </label>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey="6LchEnYqAAAAADmTaH2p7DZF5egvhRxrPKmvtBl6"
                                size="invisible"
                                badge="inline"
                            />

                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsletterSection1